import { Component, OnInit } from "@angular/core";
import { LogOutService } from "../services/log-out.service";
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from "@angular/material/sidenav";
import { NgIf } from "@angular/common";
import { SideNavComponent } from "../side-nav/side-nav.component";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-main-content",
    templateUrl: "./main-content.component.html",
    styleUrls: ["./main-content.component.scss"],
    imports: [MatDrawerContainer, NgIf, MatDrawer, SideNavComponent, MatDrawerContent, RouterOutlet]
})
export class MainContentComponent implements OnInit {
  checkLoginStatus: boolean;

  constructor(public logOutService: LogOutService) {}

  ngOnInit(): void {}

  ngDoCheck() {
    this.checkLoginStatus = this.logOutService.checkLoginUserStatus;
  }
}
